var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container"},[_c('input',{ref:"checkBoxElement",attrs:{"type":"checkbox","name":_vm.name,"id":_vm.uuid},on:{"click":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }